import React, { useEffect } from 'react';
import { useSensitiveCommunitiesContext } from 'src/contexts/sensitive-communities.context';
import { actionTypes } from 'src/ducks/sensitive-communities.duck';
import { getSensitiveCommunitiesStatus } from 'src/selectors/sensitive-communities.selector';
import SensitiveCommunitiesView from './sensitive-communities-list.view';

const SensitiveCommunities: React.FC = () => {
  const { state, actions } = useSensitiveCommunitiesContext();

  useEffect(() => {
    actions.listGET();
  }, [actions]);

  return (
    <SensitiveCommunitiesView
      loading={
        getSensitiveCommunitiesStatus(state, actionTypes.SENSITIVE_COMMUNITIES_FETCH).fetching
      }
      data={state.list}
    />
  );
};

export default SensitiveCommunities;
